// extracted by mini-css-extract-plugin
module.exports = {"draftInner":"draft-mode-banner_draftInner__l5BuK"};